import { FETCH_JWKS_RESULT } from "../actions/index";

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_JWKS_RESULT:
      return { ...state, jwks: action.payload.jwks };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Jwks.js